import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";
import { PlusIcon } from "lucide-react";
import Spinner from "../Spinner/Spinner";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    boxShadow: "none",
    border: state.isFocused ? "1px solid #ccc" : "1px solid #ddd",
    outline: "none",
    "&:hover": {
      border: "1px solid #aaa",
    },
  }),
};

const AssociateModal = ({ isOpen, onClose, id }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);

  const getCourses = async () => {
    try {
      const response = await apiServiceHandler("GET", "api/courses", {});
      const formattedCourses = response?.data?.map((course) => ({
        value: course?._id,
        label: course?.title,
      }));
      setOptions(formattedCourses);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  useEffect(() => {
    getCourses();
  }, [isOpen]);

  const hanldeSubmit = async () => {
    const payload = {
      groupId: id,
      courseId: selectedOption?.value,
    };

    try {
      setLoading(true);
      const response = await apiServiceHandler(
        "POST",
        "api/courses/associate/group",
        payload
      );
      if (response.status) {
        toastr.success(response.message);
        onClose();
        setLoading(false);
      }
    } catch (error) {
      console.error("Error associating course:", error);
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>Associate to a course</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="invite-form__fields">
          <div className="select-invite-form__field" style={{margin: '0'}}> 
            <div class="select__label">Select Course</div>
            <Select
              defaultValue={selectedOption}
              onChange={setSelectedOption}
              options={options}
              placeholder=""
              styles={customStyles}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }}>
        <button
          className="send-invite__btn"
          onClick={hanldeSubmit}
          disabled={loading}
          style={loading ? { backgroundColor: "#268bd9", border: "none" } : {}}
        >
          {loading && <div style={{marginLeft: '1rem'
          }}>
            <Spinner />
          </div> }
          <span className="send-invite-button__label">{loading ? "Associating" : "Associate"}</span>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssociateModal;
